import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import UsersCreateForm from './UsersCreateForm';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createUser } from 'store/actions/users/createUsers';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';

class UsersCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                onError: () => {
                    resolve();
                },
                onSuccess: (response) => {
                    const {
                        id,
                    } = response;

                    resolve(history.push(`/users/${ id }/show`));
                },
                values: values,
            });
        });
    }

    render() {
        const { resource, translate } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.users.title'),
                link: '/users',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.users.actions.create') } />

                    <Actions>
                        <ListButton url='/users' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <UsersCreateForm
                            { ...this.props }
                            form='users_create'
                            handleSubmitForm={ this.handleSubmitForm }
                            resource={ resource }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

UsersCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    resource: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createUser(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(UsersCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/users/create/UsersCreateContainer.js